import React, { ReactNode } from "react";
import { ConfigProvider, ThemeConfig } from "antd";
import "@fontsource/lato";
import "@fontsource/lato/300.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";

interface AntdThemeProviderProps {
  children: ReactNode;
}

const themeConfig: ThemeConfig = {
  token: {
    fontFamily: "Lato, sans-serif",
  },
};

const AntdThemeProvider: React.FC<AntdThemeProviderProps> = ({ children }) => {
  return <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>;
};

export default AntdThemeProvider;
